import React from 'react';
import { MModalHeaderProps } from './MModalHeader.types';
import * as Styled from './MModalHeader.styles';
import { ASubheader } from '../../atoms/ASubheader';
import { MButtonIcon } from '../MButtonIcon';

const COMPONENT_NAME = 'm-web-ui-kit-MModalHeader';
const TEST_ID = 'web-ui-kit-MModalHeader';

export const MModalHeader: React.FC<MModalHeaderProps> = ({ aSubheader, mButtonIcon, className }) => {
  return (
    <Styled.Wrapper data-component-name={COMPONENT_NAME} data-testid={TEST_ID} className={className}>
      <Styled.SubheaderWrapper>
        <ASubheader {...aSubheader} />
      </Styled.SubheaderWrapper>
      <Styled.ButtonWrapper>
        <MButtonIcon {...mButtonIcon} />
      </Styled.ButtonWrapper>
    </Styled.Wrapper>
  );
};
